<template>
  <div class="main">
    <!-- start: page -->
    <section class="panel panel-default">
      <header class="panel-heading">
        <h1 class="panel-title">離退宿備註</h1>
      </header>
      <div id="privacy" class="panel-collapse collapse in">
        <ckeditor v-model="content" :config="editorConfig"></ckeditor>
      </div>
    </section>
    <div class="col-md-12">
      <div class="s_tenc">
        <a @click="saveClick" class="btn-upload btn s_btn_b">儲存</a>
        <a @click="$router.go(-1);" class="btn-upload btn s_btn_g">返回</a>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@/ckeditor4";

export default {
  components: {
    ckeditor: CKEditor.component
  },
  props: [],
  data() {
    return {
      type: "stay-leave",
      content: "",
      editorConfig: {
        extraPlugins: ["colorbutton"],
        height: 500,
        toolbar: [
          ["Source"],
          ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
          ["Undo", "Redo"],
          ["RemoveFormat"],
          ["NumberedList", "BulletedList"],
          ["Outdent", "Indent"],
          ["Blockquote"],
          ["Link", "Unlink", "Anchor"],
          ["Table", "HorizontalRule"],
          ["SpecialChar"],
          "/",
          ["Styles", "Format"],
          ["Bold", "Italic", "Strike"],
          ["TextColor", "BGColor"],
          ["Maximize"],
          ["About"]
        ]
      },
    }
  },
  mounted() {
    this.$axios.get(`/api/common/treaty?type=${this.type}`).then(resp => {
      this.content = this.htmlDecode(resp.data.content);
    });
  },
  methods: {
    saveClick() {
      let errorMsgs = [];
      if (!this.content) {
        errorMsgs.push(`請填寫內容`);
      }
      if (errorMsgs.length > 0) {
        bootbox.alert(errorMsgs.join("<br/>"));
        return false;
      }
      const formData = new FormData();
      formData.append("treaty", JSON.stringify({
        content: this.htmlEncode(this.content)
      }));
      const _this = this;
      formData.append("type", this.type);
      this.$axios.post(`/api/common/saveTreaty`, formData).then(resp => {
        bootbox.alert(resp.data.msg, function () {
          if (resp.data.status === "success") {
            _this.$router.go(-1);
          }
        });
      });
    }
  }
}
</script>
